module.exports = __webpack_public_path__ + "12e5a821d55dc5b4c4d561a84eb50559.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_icon_another_team_2x.png
// module id = 121
// module chunks = 0 1 2 3 4